import {
  AppInstallResponse,
  ChangeSubscriptionResponse,
  DeleteReviewResponse,
  FlagReviewResponse, SubmitReviewResponse, UninstallAppResponse,
} from '../../../models/post-req-responses-payloads';
import { RTKQueryResponseType } from '../../../redux/api/appMarket-api-slice';
import { NotificationData } from '../../Common/Notifications/types';
import { ButtonVariant } from '@clover/web-lib-core/dist/components/CoreButton/CoreButton';
import React from 'react';
import { App, AppSubscriptionCountry } from '../../../models/app';

export enum AppActions {
  ChangeSubscription = 'buttons.change',
  PreInstall = 'buttons.connect',
  PreChangePricing = 'buttons.change',
  DeleteReview = 'buttons.delete',
  FlagReview = 'buttons.review_options.report',
  Install = 'buttons.install',
  Open = 'buttons.open_app',
  OpenOnDevice = 'buttons.open_on_device',
  SubmitReview = 'buttons.submit',
  Uninstall = 'buttons.uninstall',
  YelpConnect = 'buttons.yelp_connect'
}

export type AppActionsPostResponse =
  FlagReviewResponse
  | DeleteReviewResponse
  | ChangeSubscriptionResponse
  | SubmitReviewResponse
  | AppInstallResponse
  | UninstallAppResponse;

interface AppActionHandlePostRequestArgs<T = AppActionsPostResponse> {
  reqResponse: RTKQueryResponseType<T>;
  successNotification?: NotificationData;
  stopSuccessNotification?: boolean;
  stopAppRefetch?: boolean;
  app?: App;
}

interface SubmitReviewRequestArgs extends AppActionHandlePostRequestArgs<SubmitReviewResponse> {
  reviewId?: Uuid;
}

interface UnInstallAppArgs extends AppActionHandlePostRequestArgs {
  index?: number;
}

interface SubscriptionSelectRequestHandlerArgs extends AppActionHandlePostRequestArgs {
  selectedSubscription?: AppSubscriptionCountry;
}

export type AppActionPostRequestResponseHandler<T = AppActionsPostResponse> = (args: AppActionHandlePostRequestArgs<T>) => void
export type SubmitReviewRequestHandler = (args: SubmitReviewRequestArgs) => void;
export type AppSubscriptionSelectRequestHandler = (args: SubscriptionSelectRequestHandlerArgs) => void;
export type AppActionCallback<T> = AppActionPostRequestResponseHandler<T> | (() => void);

export interface ActionButtonProps<T = AppActionsPostResponse> extends React.HTMLAttributes<HTMLButtonElement> {
  actionCallBack?: AppActionCallback<T>;
  buttonVariant?: ButtonVariant;
  isMenuItem?: boolean;
  text?: string;
}
